import { Static } from '@adaptiva/core/common';
import { ISummarizable, Summarize } from '@adaptiva/core/summary';
import { TextConfig } from '@adaptiva/core/widgets';
import { EJavaClassNames, ServerObject } from '@adaptiva/data-service';
import { of } from 'rxjs';
import { ILlmConversation } from '../interfaces';

@Static<ISummarizable>()
export class LlmConversation extends ServerObject implements ILlmConversation {

	public static readonly className: string = EJavaClassNames.LlmConversation;

	@Summarize({
		columnDisplay: 'ObjectName',
		visible: false,
		searchable: false,
	})
	public override name: string;

	@Summarize(
		new TextConfig({
			columnDisplay: 'Conversation Name',
			isHeading: true,
			isUnique: true,
			order: -1,
			type: 'string',
		})
	)
	public displayName: string;

	@Summarize({
		visible: true,
		searchable: false,
		isHeading: true,
		columnDisplay: 'Forks',
		order: 0,
		transformers: {
			toDisplay: (c: ILlmConversation) => of(c.numForks ?? 0)
		},
	})
	public numForks: int;

	@Summarize({
		visible: true,
		isHeading: true,
		type: 'timestamp',
		order: 1,
		columnDisplay: 'Last Modification Time'
	})
	public override lastModificationTime: long = 0;

	public lastViewedFork: string;

	constructor(_from?: Partial<ILlmConversation>) {
		super(_from);

		this.displayName = _from?.displayName ?? 'New Chat';
		this.numForks = _from?.numForks ?? 0;
		this.lastViewedFork = _from?.lastViewedFork ?? '';
	}

}
